import React, { useEffect, useState } from "react";
import { ArrowUpRightIcon } from "lucide-react";
type MobileAssessmentBarProps = {
  href: string;
};
export function MobileAssessmentBar({
  href
}: MobileAssessmentBarProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > window.innerHeight * 0.65);
    handleScroll();
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-cream/20 bg-ink p-3 transition-transform duration-200 ease-out md:hidden ${visible ? "translate-y-0" : "translate-y-full"}`} aria-hidden={!visible} data-id="element-221" data-mp="1fcyloeonm3yf">
      <a href={href} tabIndex={visible ? 0 : -1} className="flex min-h-12 w-full items-center justify-center gap-3 bg-bronze px-5 py-3 text-xs font-bold uppercase tracking-[0.13em] text-cream focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cream" data-id="element-222" data-mp="1obab4ddsavpa">Start your assessment <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-223" data-mp="2cnjn76xjyrev" /></a>
    </div>;
}